import React from "react";
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

export default function NumberFormatYears(props) {
  const { inputRef, onChange, value, ...numberFormatProps } = props;

  return (
    <NumberFormat
      {...numberFormatProps}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
      value={+value}
      isNumericString
      suffix={value === "1" ? " year" : " years"}
    />
  );
}

NumberFormatYears.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Helpers/Formatters/NumberFormatYears.js